import React from 'react';
import './commoncards.scss';
import { NavLink } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
const CommonCards = ({ CardData, Title , colSizes }) => {


    return (
        <section className='cards-main'>
            <div className='common-heading'>
                <h2>{Title}</h2>
                {/* <NavLink>View all news</NavLink> */}
            </div>
            <Row>
                {CardData.map((data , index) => (
                    <Col 
                        key={index}
                        sm={12}
                        md={6}
                        lg={colSizes.lg || 6}
                        xl={colSizes.xl || 6}
                    >
                        <div className='common-card-wrapper'>
                            {/* Content Section */}
                            <div className='Content'>
                                <div className='top-image'>
                                    <img src={data.img} alt="image" />
                                </div>
                                <div className='Heading'>
                                    <h3>{data.title}</h3>
                                </div>
                                <div className='Text'>
                                    <p>{data.description}</p>
                                </div>
                                <a className='link' href={data.linkUrl}>
                                    <span>{data.linkText}</span>
                                </a>
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>
        </section>
    );
};

export default CommonCards;
